import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { Language, TranslationService } from 'angular-l10n';
import { UploadCdrService } from '../../views/upload-cdr-file/upload-cdr-file.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './app-upload-file.component.html',
  styleUrls: ['./app-upload-file.component.css'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: AppUploadFileComponent, multi: true}
  ]
})
export class AppUploadFileComponent implements OnInit {

  @Language() lang: string;

  @ViewChild('fileUploader') fileUploader: any;
  /** Upload Files Event*/
  @Output() uploadFiles: EventEmitter<any> = new EventEmitter();

  /** File Selected Event */
  @Output() filesSelected: EventEmitter<any> = new EventEmitter();
  /** File accepted types */
  @Input() accept: string = '.csv';
  /** File Has Password Field */
  @Input() hasPassword: boolean = false;
  /** File Size Validation function */
  @Input() validateSize: Function;
  /** File Type Validation function */
  @Input() validateType: Function;
  /** File Maximum Selection Validation function */
  @Input() validateMultipleMax: Function;
  /** File Minimum Selection Validation function */
  @Input() validateMultipleMin: Function;
  /** File Size Validation function - Error Message */
  @Input() errorSize: string;
  /** File Type Validation function - Error Message */
  @Input() errorType: string;
  /** File Multiple Maximum Validation function - Error Message */
  @Input() errorMultipleMax: string;
  /** File Multiple Minimum Validation function - Error Message */
  @Input() errorMultipleMin: string;

  /** File Uploading Flag */
  @Input() name: string;
  /** select Multiple Files */
  @Input() multiple: boolean = false;
  /** Maximum Number of Multiple Selected Files */
  @Input() multipleMax: number = 1;
  /** Minimum Number of Multiple Selected Files */
  @Input() multipleMin: number = 1;

  maxArr : any[]=[];

  /** File Uploading Flag */
  uploading: boolean = false;
  /** File Upload , set url to backend url */
  uploader: FileUploader = new FileUploader({url: 'http://localhost'});

  /** Is File Dragged Over */
  isFileOver: boolean = false;

  /**The internal data model*/
  files: File[]= [];
  filesRead: any[] = [];
  password: string = '';
  selectedTenant: number;

  isValid: boolean = true;
  hasTenant : boolean = false;
  hasErrors: any = {};

  constructor(private translationService: TranslationService, private fileService: UploadCdrService) {}

  ngOnInit() {
    this.selectedTenant = this.fileService.selectedTenant || null;
    this.maxArr = Array.from({length: this.multipleMax}, (v, i) => i);
  }

  /**is File Draged Over Control */
  fileOver(event: any): void {
    this.isFileOver = event;
  }

  /** Select a File */
  fileSelected(i, files: any) {
    if (files && files.length>0) {
        this.files.splice(i, 1, files[0]);    
        this.filesSelected.emit(this.files);
    }    
  }

  get fileName() {
      if (!this.files || this.files.length === 0) {
        return null;
      } else {
          let names = '';
          for (const file of this.files) {
            names += ((names.length > 0) ? ', ' : '') + file.name;
          }
          return names;
      }
  }


  validateFunction(func, ...arg) {
    let invalid = false;
    for (const file of this.files) {
        invalid = (func && !func(...arg, file));
        if (invalid) {
            break;
        }
    }
    return invalid;
  }

  handleValidation(type) {
    let invalid = false;
      if (!this.files || this.files.length === 0) {
        this.hasErrors = {};
      } else {
        switch (type) {
            case 'size':
                invalid = this.validateFunction(this.validateSize);
                break;
            case 'type':
                invalid = this.validateFunction(this.validateType, this.accept);
                break;
            case 'max':
                invalid = (this.multiple && this.validateMultipleMax && !this.validateMultipleMax(+this.multipleMax, this.files));
                break;
            case 'min':
                invalid = (this.multiple && this.validateMultipleMin && !this.validateMultipleMin(+this.multipleMin, this.files));
                break;
        }
    }

    if (!invalid && this.hasErrors[type]) {
        delete this.hasErrors[type];
    } else if (invalid) {
        this.hasErrors[type] = true;
    }
    this.isValid = (Object.keys(this.hasErrors).length === 0);

    return invalid;
  }

  upload() {
      this.filesRead = [];
      this.uploading = true;
      this.processNextFile();

  }
  processNextFile() {
    if (this.files.length > this.filesRead.length) {
        const file = this.files[this.filesRead.length]
        if (file) {
            this.readFile(file);
        }
    }
  }

  readFile(file) {
    const reader = new FileReader();
    reader.onload = this.handleReaderLoaded.bind(this, file);
    reader.readAsBinaryString(file);
  }

  handleReaderLoaded(file, readerEvt) {
    if(this.fileService.selectedTenant){
        this.selectedTenant = this.fileService.selectedTenant;
    }
    const binaryString = readerEvt.target.result;
    let data: any = {
        tenant_id: Number(this.selectedTenant),
        fileName: file.name,
        fileBytes: btoa(binaryString)
    }
    this.filesRead.push(data);
    this.processNextFile();
    if (this.filesRead.length === this.files.length) {
        if (this.multiple) {
            data = this.filesRead;
        } else {
            data = this.filesRead[0];
        }

        if (this.password) {
            data.password = this.password;
        }

        this.uploadFiles.emit({
            data: data,
            callback: this.uploadCallBack.bind(this),
            errorCallback: this.errorUploadCallBack.bind(this)
        });
    }
  }

  uploadCallBack() {
    this.uploading = false;
    this.files = this.filesRead = [];
    this.hasErrors = {};
    this.isValid = true;
    this.password = '';
    this.fileUploader.nativeElement.value = '';
  }

  errorUploadCallBack() {
    this.uploading = false;
    this.fileUploader.nativeElement.value = '';
  }



}




// WEBPACK FOOTER //
// ./src/app/components/app-upload-file/app-upload-file.component.ts